/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AdminClusterFindOrphans = {
  id: 'admin-cluster.find-orphans.get',
  tag: 'Admin',
  summary: 'Find orphans clusters',
  description: 'Get a list of orphan clusters',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/cluster`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              workspaceId: z.string(),
              customerId: z.string(),
              clusterId: z.string(),
              status: ZodTypes.ClusterStatus,
              whitelisted: z.boolean(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
